export default __webpack_public_path__ + "static/media/kasper_full.f77cf82d.jpeg";